import classNames from 'classnames';

import { TypographyProps } from '@hcs/types';

import typographyStyles from '../css/vars/modules/Typography.module.css';

const classNameFontSize = ({ fontSize }: TypographyProps = {}) => {
  switch (fontSize) {
    case 'xxs':
      return typographyStyles.fontSizeXXS;
    case 'xs':
      return typographyStyles.fontSizeXS;
    case 'sm':
      return typographyStyles.fontSizeSM;
    case 'md':
      return typographyStyles.fontSizeMD;
    case 'lg':
      return typographyStyles.fontSizeLG;
    case 'xl':
      return typographyStyles.fontSizeXL;
    case 'xxl':
      return typographyStyles.fontSizeXXL;
  }
};

const classNameFontWeight = ({ fontWeight }: TypographyProps = {}) => {
  switch (fontWeight) {
    case 'book':
      return typographyStyles.fontWeightBook;
    case 'heavy':
      return typographyStyles.fontWeightHeavy;
    case 'black':
      return typographyStyles.fontWeightBlack;
  }
};

const classNameFontFamily = ({ fontFamily }: TypographyProps = {}) => {
  if (!fontFamily) return undefined;
  switch (fontFamily) {
    case 'code':
      return typographyStyles.fontFamilyCode;
    default:
      return typographyStyles.fontFamilyDefault;
  }
};

const classNameFont = ({ font, fontSize }: TypographyProps = {}) => {
  if (!font) return undefined;
  // Return if size undefined, but do not return if invalid for font option
  switch (font) {
    case 'display':
      return typographyStyles.fontDisplay;
    case 'headline':
      switch (fontSize) {
        case 'xl':
          return typographyStyles.fontHeadlineXL;
        case 'md':
          return typographyStyles.fontHeadlineMD;
        case 'lg':
        case undefined:
          return typographyStyles.fontHeadlineLG;
      }
      return undefined;
    case 'label':
      switch (fontSize) {
        case 'md':
          return typographyStyles.fontLabelMD;
        case 'xs':
          return typographyStyles.fontLabelXS;
        case 'sm':
        case undefined:
          return typographyStyles.fontLabelSM;
      }
      return undefined;
    case 'body':
      switch (fontSize) {
        case 'md':
          return typographyStyles.fontBodyMD;
        case 'xs':
          return typographyStyles.fontBodyXS;
        case 'sm':
        case undefined:
          return typographyStyles.fontBodySM;
      }
      return undefined;
  }
};
// Keep our components/features simple, only expose one interface
export const classNamesTypography = (
  // Support passing props without having pick out the typography ones every time
  allProps?: TypographyProps & { [key: string | number | symbol]: unknown },
) => {
  const { fontSize, fontWeight, fontFamily, font } = allProps || {};
  const typographyProps: TypographyProps = {
    fontSize,
    fontWeight,
    fontFamily,
    font,
  };
  return classNames(
    classNameFontSize(typographyProps),
    classNameFontWeight(typographyProps),
    classNameFontFamily(typographyProps),
    classNameFont(typographyProps),
  );
};
